export default {
	navbar: {
		searchPlaceholder: "Search",
		latest: "Latest offers",
		sales: "Sales",
		under10: "Under 10€",
		grabIt: "Almost gone",
        stores: "Stores",
        allCategories: "All Categories",
		dropdown: {
			welcome: "Welcome",
			myOrders: "My orders",
			myStores: "My stores",
			wishlist: "Wish List",
			cart: "My Cart",
			settings: "Settings",
            createStore: "Create Store",
			help: "Help",
			logout: "Logout",
			login: "Login",
			register: "Register",
			chat: "Messages",
            notificationCenter: "Notification center"
		},
	},
    home: "Home"
};
